import { Grid, Checkbox } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomTextField from 'components/Input/CustomTextField';
import FormRowItemContent from 'components/Global/FormRowItemContent';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomSelect from 'components/Input/CustomSelect';
import CustomRadio from 'components/CustomRadio';
import { SEvenRow } from 'style/CommonStyledComponent';
import { SET_LOCAL_SAE_REPORT } from 'store/key';

const SeriousAdverseEvents = ({
    classes,
    remoteDetail,
    updateRemoteDetail,
    isViewOnly,
    dispatch,
    forceErrorDisplay,
    setSubjectRefCodeValid,
    setSubjectRefInitialsValid,
    setSubjectRefAgeValid,
    setSubjectRefSexValid,
    setRelevantMedicalHistoryValid,
    setNatureOfSaeValid,
    setSaeStartDateValid,
    setSaeStopDateValid,
    checkSeriousnessValid,
    systemMsg,
    setTypeOfSaeValid,
    setFrequencyValid,
}) => {
    const handleSeriousness = (key, checked) => {
        updateRemoteDetail(key, checked ? true : null);
    };

    const changeSaeNotResolved = (e) => {
        const value = e.target.checked ? true : null;
        if (value) {
            dispatch({
                type: SET_LOCAL_SAE_REPORT,
                payload: {
                    remoteDetail: {
                        ...remoteDetail,
                        saeStopDate: null,
                        saeNotResolved: value,
                    },
                },
            });
        } else {
            updateRemoteDetail('saeNotResolved', value);
        }
    };

    return (
        <>
            <Grid container className={classes.subItem}>
                <FormRowItemContent
                    isSigleRow
                    sigleRowTitleXs={2}
                    leftChildren={{
                        title: 'Subject reference:',
                        value: (
                            <Grid container justify="space-between">
                                <Grid container item xs={2}>
                                    <CustomTextField
                                        disabled={isViewOnly}
                                        label="Code:"
                                        value={remoteDetail.subjectRefCode}
                                        forceErrorDisplay={forceErrorDisplay}
                                        validators={['isRequired']}
                                        maxLength={255}
                                        isValidValue={(isValid) => setSubjectRefCodeValid(isValid)}
                                        onChange={(e) => {
                                            updateRemoteDetail('subjectRefCode', e.target.value);
                                        }}
                                    />
                                </Grid>
                                <Grid container item xs={2}>
                                    <CustomTextField
                                        disabled={isViewOnly}
                                        label="Initials:"
                                        value={remoteDetail.subjectRefInitials}
                                        forceErrorDisplay={forceErrorDisplay}
                                        validators={['isRequired']}
                                        maxLength={255}
                                        isValidValue={(isValid) => setSubjectRefInitialsValid(isValid)}
                                        onChange={(e) => {
                                            updateRemoteDetail('subjectRefInitials', e.target.value);
                                        }}
                                    />
                                </Grid>
                                <Grid container item xs={2}>
                                    <CustomTextField
                                        disabled={isViewOnly}
                                        label="Age:"
                                        value={remoteDetail.subjectRefAge}
                                        forceErrorDisplay={forceErrorDisplay}
                                        validators={['isRequired']}
                                        maxLength={255}
                                        isValidValue={(isValid) => setSubjectRefAgeValid(isValid)}
                                        onChange={(e) => {
                                            updateRemoteDetail('subjectRefAge', e.target.value);
                                        }}
                                    />
                                </Grid>
                                <Grid container item xs={2}>
                                    <CustomSelect
                                        disabled={isViewOnly}
                                        fullWidth
                                        options={[
                                            { key: 'M', label: 'Male' },
                                            { key: 'F', label: 'Female' },
                                        ]}
                                        label="Sex"
                                        name="sex"
                                        value={remoteDetail.subjectRefSex}
                                        setValue={(e) => updateRemoteDetail('subjectRefSex', e.target.value)}
                                        validators={['isRequired']}
                                        forceErrorDisplay={forceErrorDisplay}
                                        isValidValue={(isValid) => setSubjectRefSexValid(isValid)}
                                    />
                                </Grid>
                            </Grid>
                        ),
                    }}
                />

                <FormRowItemContent
                    isSigleRow
                    sigleRowTitleXs={2}
                    rowAlignItems="baseline"
                    leftChildren={{
                        title: 'Relevant medical history & current treatments:',
                        value: (
                            <CustomTextField
                                disabled={isViewOnly}
                                label={`Relevant medical history & current treatments`}
                                value={remoteDetail.relevantMedicalHistory}
                                forceErrorDisplay={forceErrorDisplay}
                                validators={['isRequired']}
                                isTextArea
                                textAreaMinRow={6}
                                maxLength={3000}
                                isValidValue={(isValid) => setRelevantMedicalHistoryValid(isValid)}
                                onChange={(e) => {
                                    updateRemoteDetail('relevantMedicalHistory', e.target.value);
                                }}
                            />
                        ),
                    }}
                />
                <FormRowItemContent
                    isSigleRow
                    sigleRowTitleXs={2}
                    rowAlignItems="baseline"
                    leftChildren={{
                        title: 'Nature of SAE:(Describe temporal relationship with intervention & other concomitant therapies):',
                        value: (
                            <CustomTextField
                                disabled={isViewOnly}
                                label={`Nature of SAE:(Describe temporal relationship with intervention & other concomitant therapies)`}
                                value={remoteDetail.natureOfSae}
                                forceErrorDisplay={forceErrorDisplay}
                                validators={['isRequired']}
                                isTextArea
                                textAreaMinRow={6}
                                maxLength={3000}
                                isValidValue={(isValid) => setNatureOfSaeValid(isValid)}
                                onChange={(e) => {
                                    updateRemoteDetail('natureOfSae', e.target.value);
                                }}
                            />
                        ),
                    }}
                />

                <SEvenRow style={{ marginTop: 20 }} labelWidth={150}>
                    <div style={{ alignItems: 'center'}}>
                        <div>SAE start date:</div>
                        <div>
                            <div style={{ width: 200 }}>
                                <CustomDatePicker
                                    disabled={isViewOnly}
                                    value={remoteDetail.saeStartDate}
                                    onChange={(date) => {
                                        updateRemoteDetail('saeStartDate', date);
                                    }}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                    isValidValue={(isValid) => setSaeStartDateValid(isValid)}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ alignItems: 'center' }}>
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', left: 0, bottom: -57, width: 500 }}>
                                *Follow-up should be reported until SAE is resolved.
                            </div>
                            SAE stop date:
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ width: 200 }}>
                                <CustomDatePicker
                                    disabled={isViewOnly || remoteDetail.saeNotResolved}
                                    value={remoteDetail.saeStopDate}
                                    onChange={(date) => {
                                        updateRemoteDetail('saeStopDate', date);
                                    }}
                                    validators={remoteDetail.saeNotResolved ? [] : ['isRequired']}
                                    forceErrorDisplay={forceErrorDisplay}
                                    isValidValue={(isValid) => setSaeStopDateValid(isValid)}
                                />
                            </div>
                            <div style={{ marginLeft: 10 }}>
                                <Checkbox
                                    disabled={isViewOnly}
                                    checked={remoteDetail.saeNotResolved}
                                    onChange={changeSaeNotResolved}
                                    size="small"
                                    color="primary"
                                />
                                not resolved*
                            </div>
                        </div>
                    </div>
                </SEvenRow>

                <SEvenRow style={{ marginTop: 20, width: '100%' }} labelWidth={150}>
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                                Type of SAE:
                            </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <CustomRadio
                                disabled={isViewOnly}
                                isRequired
                                forceErrorDisplay={forceErrorDisplay}
                                isValidValue={(isValid) => setTypeOfSaeValid(isValid)}
                                onChange={(e) => {
                                    const value = e.target.value === 'true';
                                    updateRemoteDetail('typeOfSae', value);
                                }}
                                value={remoteDetail.typeOfSae !== null ? remoteDetail.typeOfSae : null}
                                operators={[
                                    {
                                        key: false,
                                        label: 'Initial',
                                    },
                                    {
                                        key: true,
                                        label: 'Follow up',
                                    },
                                ]}
                            />
                        </div>
                    </div>
                    <div>
                        <div></div>
                        <div></div>
                    </div>
                </SEvenRow>

                <SEvenRow style={{ marginTop: 20 }} labelWidth={150}>
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            Frequency:
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}s>
                            <CustomRadio
                                isRequired
                                forceErrorDisplay={forceErrorDisplay}
                                isValidValue={(isValid) => setFrequencyValid(isValid)}
                                disabled={isViewOnly}
                                onChange={(e) => {
                                    updateRemoteDetail('frequency', Number(e.target.value));
                                }}
                                value={remoteDetail.frequency !== null ? Number(remoteDetail.frequency) : null}
                                operators={[
                                    {
                                        key: 0,
                                        label: 'One episode',
                                    },
                                    {
                                        key: 1,
                                        label: 'Intermittent',
                                    },
                                    {
                                        key: 2,
                                        label: 'Continuous',
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </SEvenRow>

                <SEvenRow style={{ marginTop: 20 }} labelWidth={150}>
                    <div>
                        <div style={{
                            paddingTop: 10,
                        }}>
                            Seriousness:
                            {forceErrorDisplay && !checkSeriousnessValid() &&
                            <div style={{ color: 'red', fontSize: 12, fontWeight: 'normal', marginTop: 10 }}>{systemMsg.required}</div>}
                        </div>
                        <div>
                            <Grid container className={classes.subItem}>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isDeath', checked)}
                                        value={[remoteDetail.isDeath]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Death',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isLiftThreatening', checked)}
                                        value={[remoteDetail.isLiftThreatening]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Life threatening',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isSignificantDisability', checked)}
                                        value={[remoteDetail.isSignificantDisability]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Significant disability / incapacity',
                                            },
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container className={classes.subItem}>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isRequiredHospitalization', checked)}
                                        value={[remoteDetail.isRequiredHospitalization]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Required hospitalization',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isPersisentDisability', checked)}
                                        value={[remoteDetail.isPersisentDisability]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Persistent disability / incapacity',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isProlongedHospitalization', checked)}
                                        value={[remoteDetail.isProlongedHospitalization]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Prolonged hospitalization',
                                            },
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container className={classes.subItem}>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isCongenitalAnomaly', checked)}
                                        value={[remoteDetail.isCongenitalAnomaly]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Congenital anomaly / birth defect',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isNone', checked)}
                                        value={[remoteDetail.isNone]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'None of the above',
                                            },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item xs={4}>
                                    <CustomCheckbox
                                        disabled={isViewOnly}
                                        isAllowChangeUnChecked
                                        onItemChange={(key, checked) => handleSeriousness('isOther', checked)}
                                        value={[remoteDetail.isOther]}
                                        defaultData={[
                                            {
                                                key: true,
                                                display: 'Other medically important condition',
                                            },
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </SEvenRow>
            </Grid>
        </>
    );
};
export default SeriousAdverseEvents;
